export default {
  get_all: { method: "get", url: "api/clientes" },
  get_by_text: { method: "get", url: "api/clientes/link-filter" },
  link_to_partner: { method: "post", url: "api/clientes/link" },
  show: { method: "get", url: "api/clientes{/id}" },
  store: { method: "post", url: "api/clientes" },
  update: { method: "put", url: "api/clientes{/id}" },
  delete: { method: "delete", url: "api/clientes{/id}" },

  get_users: { method: "get", url: "api/clientes/users{/id}" },
  get_pagamentos: { method: "get", url: "api/clientes-pagamentos" },
};
